"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _avatarConstants = require("../avatar/avatarConstants");

var _context = require("../context");

var _link = require("../link");

var _text = require("../text");

var _utils = require("../utils");

var _constants = require("./constants");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledUsername = (0, _context.styledWithTheme)(_text.Text)(function (_ref) {
  var theme = _ref.theme,
      color = _ref.color;
  return {
    color: theme.selectors.color(color || _constants.AVATAR_USERNAME_TEXT_DEFAULT_COLOR)
  };
});
var StyledLink = (0, _context.styledWithTheme)(_link.Link)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    fontWeight: theme.selectors.fontWeight('regular'),
    ':hover': {
      textDecoration: 'underline'
    }
  };
});

var onClick = function onClick(e) {
  // Prevent the event from bubbling, which stops issues
  // such as onRowClick being fired when clicking the link
  // in tables.
  e.stopPropagation();
};

var ChipAvatarLink = function ChipAvatarLink(_ref3) {
  var username = _ref3.username,
      fontSize = _ref3.fontSize,
      newTabHiddenText = _ref3.newTabHiddenText,
      colorScheme = _ref3.colorScheme,
      _ref3$isClickable = _ref3.isClickable,
      isClickable = _ref3$isClickable === void 0 ? true : _ref3$isClickable;
  var linkCssValues = {
    color: colorScheme === _interfaces.ChipColorScheme.DarkBackground ? _constants.AVATAR_USERNAME_LINK_INVERTED_COLOR : _constants.AVATAR_USERNAME_LINK_DEFAULT_COLOR,
    fontSize: fontSize,
    textDecoration: colorScheme === _interfaces.ChipColorScheme.DarkBackground ? 'underline' : 'none'
  };
  var accessibleUsername = (0, _core.jsx)(_react.default.Fragment, null, username, (0, _core.jsx)("span", {
    "aria-hidden": "true"
  }, '@'));
  var newTabHiddenTextId = (0, _react.useMemo)(function () {
    return "new-tab-hidden-text-".concat((0, _utils.getUniqueId)(), "-id");
  }, []);

  if (!isClickable) {
    return (0, _core.jsx)(StyledUsername, {
      fontSize: fontSize,
      color: colorScheme === _interfaces.ChipColorScheme.DarkBackground ? _constants.AVATAR_USERNAME_TEXT_INVERTED_COLOR : _constants.AVATAR_USERNAME_TEXT_DEFAULT_COLOR
    }, accessibleUsername);
  }

  return (0, _core.jsx)(StyledLink, (0, _extends2.default)({}, linkCssValues, {
    href: "".concat(_avatarConstants.PHONE_TOOL_URL).concat(username),
    onClick: onClick,
    target: "_blank",
    "aria-describedby": newTabHiddenTextId
  }), accessibleUsername, (0, _core.jsx)("span", {
    hidden: true,
    id: newTabHiddenTextId
  }, newTabHiddenText));
};

var _default = ChipAvatarLink;
exports.default = _default;